(function () {
  if (window.SalutMmenuLazy) return;

  const inflight = new WeakMap();
  const SKELETON_ROWS = 8;
  const FETCH_TIMEOUT = 15000;

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function backButton(menu) {
    const template = menu.querySelector('template[data-salut-back]');
    return template ? template.content.firstElementChild.cloneNode(true) : null;
  }

  function render(screen, nodes) {
    const restoreFocus = screen.contains(document.activeElement);
    screen.replaceChildren(...nodes);
    if (!restoreFocus) return;
    const back = screen.querySelector('.salut-mmenu__back');
    if (back) back.focus({ preventScroll: true });
  }

  function skeleton(screen, menu) {
    const wrapper = element('div', 'salut-mmenu-skeleton');
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(element('span', 'salut-skeleton salut-mmenu-skeleton__title'));
    for (let index = 0; index < SKELETON_ROWS; index++) {
      wrapper.appendChild(element('span', 'salut-skeleton salut-mmenu-skeleton__row'));
    }
    const back = backButton(menu);
    render(screen, back ? [back, wrapper] : [wrapper]);
    screen.setAttribute('aria-busy', 'true');
  }

  function failure(screen) {
    const menu = screen.closest('salut-mmenu');
    if (!menu) return;
    delete screen.dataset.loaded;
    const box = element('div', 'salut-mmenu-error');
    const message = element('p', 'salut-mmenu-error__text', menu.dataset.errorText);
    message.setAttribute('role', 'alert');
    const retry = element('button', 'salut-mmenu-error__retry', menu.dataset.retryText);
    retry.type = 'button';
    retry.setAttribute('data-salut-retry', '');
    box.append(message, retry);
    const back = backButton(menu);
    render(screen, back ? [back, box] : [box]);
    screen.removeAttribute('aria-busy');
  }

  function sectionUrl(menu, screen) {
    const root = (menu.dataset.root || '/').replace(/\/+$/, '');
    return root + '/?section_id=' + encodeURIComponent(screen.dataset.section);
  }

  function fetchSection(url) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT);
    return fetch(url, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .finally(() => clearTimeout(timer));
  }

  function load(screen) {
    if (screen.dataset.loaded === 'true') return Promise.resolve();
    if (inflight.has(screen)) return inflight.get(screen);
    const menu = screen.closest('salut-mmenu');
    if (!menu) return Promise.resolve();
    skeleton(screen, menu);
    const promise = fetchSection(sectionUrl(menu, screen))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('.shopify-section') || doc.body;
        if (!content.firstElementChild) throw new Error('empty');
        render(screen, [...content.childNodes]);
        screen.removeAttribute('aria-busy');
        screen.dataset.loaded = 'true';
        screen.dispatchEvent(new CustomEvent('salut-mmenu:loaded', { bubbles: true }));
      })
      .catch(() => failure(screen))
      .finally(() => inflight.delete(screen));
    inflight.set(screen, promise);
    return promise;
  }

  document.addEventListener('salut-mmenu:open', (event) => {
    event.detail.menu.querySelectorAll('[data-screen][data-section]').forEach((screen) => {
      if (screen.dataset.lazy !== 'manual') load(screen);
    });
  });

  document.addEventListener('salut-mmenu:screen', (event) => {
    const name = event.detail.name;
    const screen = [...event.target.querySelectorAll('[data-screen][data-section]')]
      .find((node) => node.dataset.screen === name && node.dataset.lazy === 'manual');
    if (screen) load(screen);
  });

  document.addEventListener('click', (event) => {
    const retry = event.target.closest('[data-salut-retry]');
    if (!retry) return;
    const screen = retry.closest('[data-screen]');
    if (screen) load(screen);
  });

  window.SalutMmenuLazy = { load: load, fail: failure, fetchSection: fetchSection, sectionUrl: sectionUrl };
})();
